const {AoflElement, store, clickTrackerMixin} = aofljs;
/**
 * @summary DownloadAppContent
 * @class DownloadAppContent
 * @extends {AoflElement}
 */
class DownloadAppContent extends clickTrackerMixin(AoflElement) {
  /**
   * Creates an instance of DownloadAppContent.
   * @memberof DownloadAppContent
   */
  constructor() {
    super(store);
    this.isAmazonBrowser = /Silk/.test(navigator.userAgent);
    this.isIos = (Object.keys(window.isMobile.apple).some((key) => window.isMobile.apple[key])
    || navigator.platform.toUpperCase().indexOf('MAC') >= 0);
    this.appStoreUrl;
    this.setUrls();
  }

  /**
   *
   * @memberof DownloadAppContent
   */
  connectedCallback() {
    super.connectedCallback();
  }

  /**
   *
   * @readonly
   * @static
   * @memberof DownloadAppContent
   */
  static get is() {
    return 'download-app-content';
  }

  /**
   *
   * @memberof DownloadAppContent
   * Sets the appStoreUrl based on user's device
   */
  setUrls() {
    if (this.isAmazonBrowser) {
      this.appStoreUrl = 'amzn://apps/android?asin=B00IMQFIZ6';
    } else if (this.isIos) {
      this.appStoreUrl = 'https://itunes.apple.com/us/app/early-learning-academy/id586328581?openbrowser&mt=8';
    } else {
      this.appStoreUrl = 'https://play.google.com/store/apps/details?id=mobi.abcmouse.academy_goo';
    }
  }
}

window.customElements.define(DownloadAppContent.is, DownloadAppContent);



// WEBPACK FOOTER //
// ./download_app/es-US/js/download-app-content/download-app-content.js